export const CHANGE_PARAMS = "CHANGE_PARAMS";
export const RECEIVE_SEARCH_RESULT = "RECEIVE_SEARCH_RESULT";
export const RECEIVE_SEARCH_RESULT_FAILED = "RECEIVE_SEARCH_RESULT_FAILED";
export const REQUEST_SEARCH_RESULT = "REQUEST_SEARCH_RESULT";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_RESULTS_PER_PAGE = "CHANGE_RESULTS_PER_PAGE";
export const CHANGE_RESULTS_TOTAL = "CHANGE_RESULTS_TOTAL";
export const CHANGE_SORT = "CHANGE_SORT";
export const CHANGE_SORT_DIRECTION = "CHANGE_SORT_DIRECTION";
export const RECEIVE_ERROR = "RECEIVE_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";

export function paramsChanged(params) {
	return {
		type: CHANGE_PARAMS,
		data: {
			params,
		},
	};
}

export function clearSearch() {
	return {
		type: CLEAR_SEARCH,
	};
}

export function requestResult() {
	return {
		type: REQUEST_SEARCH_RESULT,
	};
}

export function changePage(data) {
	return {
		type: CHANGE_PAGE,
		data,
	};
}

export function changeResultsPerPage(data) {
	return {
		type: CHANGE_RESULTS_PER_PAGE,
		data,
	};
}

export function changeResultsTotal(data) {
	return {
		type: CHANGE_RESULTS_TOTAL,
		data,
	};
}

export function changeSortColumn(data) {
	return {
		type: CHANGE_SORT,
		data,
	};
}

export function changeSortDirection(data) {
	return {
		type: CHANGE_SORT_DIRECTION,
		data,
	};
}

export function receiveResult(result) {
	return {
		type: RECEIVE_SEARCH_RESULT,
		data: {
			result,
		},
	};
}

export function receiveResultFailed(error) {
	return {
		type: RECEIVE_SEARCH_RESULT_FAILED,
		data: {
			error,
		},
	};
}
